export const seasonInfoKeys = {
	seasonInfo: (organizationUuid: string, teamLeagueUuid: string, seasonUuid?: string | null) =>
		[`SEASON_INFO`, organizationUuid, teamLeagueUuid, seasonUuid] as const
} as const;
